import React from 'react';
import classnames from 'classnames';

import StrapiButton from '../../StrapiLink/StrapiButton';
import SpeechBubble from '../../SpeechBubble';
import { CourseCtaPanelFragment, LinkComponentFragment, Maybe } from '../../../../graphql.schema';
import { useImageResize } from '../../../hooks/useImageResize';
import { fullImageUrl } from '../../../lib/helpers';

import * as styles from './index.module.scss';

export type CourseCtaPanelFragmentProps = CourseCtaPanelFragment & {
  optional_link: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>
};

export const StrapiCourseCTAPanel = ({ image, description, speechBubbleText, optional_link:link }: CourseCtaPanelFragmentProps) => {
  const { imageUrl, imageStyle, imageWrapper } = useImageResize(image)
  return (
    <section className={styles.wrapper}>
      <div className="columns">
        <div ref={imageWrapper} className={classnames(styles.image, 'column is-5 pb-0')}>
          <img alt={image?.alternativeText ?? image?.caption ?? ''} width={image?.width} height={image?.height} style={imageStyle} src={fullImageUrl(imageUrl)} loading="lazy" />
        </div>
        <div className={classnames(styles.info, 'column is-5 p-4')}>
          <SpeechBubble variant="brand-b" speechBubbleText={speechBubbleText ?? ''} />
          <p className="is-text-2 has-text-white mb-3">{description}</p>
          {link && <StrapiButton type="secondary" key={link?.title} {...(link as LinkComponentFragment)} />}
        </div>
      </div>
    </section>
  );
};
